import { uiNotificationService } from '@/utils/apis'

export async function getUserNotifications(isRead: boolean = false) {
  return await uiNotificationService.getUINotificationsByUserIdAndIsRead({
    isRead
  })
}
